import React, { useState, useEffect } from 'react';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { Label } from '../../components/Label';
import { Select } from '../../components/Select';
import api from '../../services/api';
import { toast } from 'sonner';

interface MenuNovoModeloProps {
  onClose: () => void;
  onSuccess: () => void;
}

export const MenuNovoModelo: React.FC<MenuNovoModeloProps> = ({ onClose, onSuccess }) => {
  const [nome, setNome] = useState('');
  const [material, setMaterial] = useState('');
  const [loading, setLoading] = useState(false);
  const [materiais, setMateriais] = useState<{ id: number; nome: string }[]>([]);
  const [loadingMateriais, setLoadingMateriais] = useState(true);

  useEffect(() => {
    const fetchMateriais = async () => {
      setLoadingMateriais(true);
      try {
        const res = await api.get('/api/v1/materiais/');
        setMateriais(res.data);
      } catch {
        setMateriais([]);
      } finally {
        setLoadingMateriais(false);
      }
    };
    fetchMateriais();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nome.trim() || !material) {
      toast.error('Preencha todos os campos');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/v1/modelos/', { nome, material });
      toast.success('Modelo cadastrado com sucesso!');
      setNome('');
      setMaterial('');
      onSuccess();
      onClose();
    } catch (err) {
      toast.error('Erro ao cadastrar modelo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="menu-novo-material-overlay">
      <div className="menu-novo-material">
        <h3 className="menu-novo-material-title">Novo Modelo</h3>
        <form onSubmit={handleSubmit}>
          <Label htmlFor="nome-modelo">Nome do modelo</Label>
          <Input
            id="nome-modelo"
            value={nome}
            onChange={e => setNome(e.target.value)}
            placeholder="Digite o nome"
            autoFocus
          />
          <Label htmlFor="material-modelo">Material</Label>
          <Select
            id="material-modelo"
            value={material}
            onChange={e => setMaterial(e.target.value)}
            options={materiais.map(m => ({ value: m.id, label: m.nome }))}
            emptyMessage={loadingMateriais ? 'Carregando materiais...' : 'Nenhum material cadastrado'}
            disabled={loadingMateriais}
          />
          <div className="menu-novo-material-actions">
            <Button type="button" variant="secondary" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? 'Salvando...' : 'Cadastrar'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
